export const FETCH_EVALUATIONS_REQUEST = "FETCH_EVALUATIONS_REQUEST";
export const FETCH_EVALUATIONS_SUCCESS = "FETCH_EVALUATIONS_SUCCESS";
export const FETCH_EVALUATIONS_FAILURE = "FETCH_EVALUATIONS_FAILURE";

export const SAVE_EVALUATION_REQUEST = "SAVE_EVALUATION_REQUEST";
export const SAVE_EVALUATION_SUCCESS = "SAVE_EVALUATION_SUCCESS";
export const SAVE_EVALUATION_FAILURE = "SAVE_EVALUATION_FAILURE";

export const CHANGE_EVALUATION_STATUS_REQUEST = "CHANGE_EVALUATION_STATUS_REQUEST";
export const CHANGE_EVALUATION_STATUS_SUCCESS = "CHANGE_EVALUATION_STATUS_SUCCESS";
export const CHANGE_EVALUATION_STATUS_FAILURE = "CHANGE_EVALUATION_STATUS_FAILURE";
